<template>
   <modal>
      <div slot="header">
         <span class="red-header">Uh-oh</span>
      </div>

      <div slot="subhead">
         {{message.subheadText}}
      </div>

      <div slot="body">
         <div class="modal-input-explain">
            {{message.messageText}}
             <ul v-if="message.list && message.list.length > 0" class="modal-error-list">
               <li
                  v-for="item in message.list"
                  :key="item"
               >{{item}}</li>
            </ul>
         </div>
      </div>

      <div slot="footer">
         <button 
            v-if="message.action" 
            @click.stop.prevent="handleBtnClick" 
            class="btn-yellow">
            {{message.buttonText}}
         </button>
      </div>
   </modal>
</template>

<script>
import Modal from './Modal';

export default {

   props: {
      title: String,
      message: {
         type: Object,
         required: true
      },
   },

   methods: {
      handleBtnClick() {
         this.message.action();
      }
   },

   components: {
      Modal
   }
   
}
</script>
